(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-confirmed-order.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-confirmed-order.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils.constants,
  SHIPPING_COST = _svs$ticketsOrderHome.SHIPPING_COST,
  GIFT = _svs$ticketsOrderHome.OrderType.GIFT;
const getOrderItemsAsync = svs.ticketsOrderHome.services.getOrderItemsAsync;
const getProductNameAndPrice = svs.ticketsOrderHome.utils.getProductNameAndPrice;
const useIsMounted = svs.ticketsOrderHome.hooks.useIsMounted;
const formatGiftAddress = giftAddress => {
  if (!giftAddress) {
    return null;
  }
  return {
    name: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.firstName,
    surname: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.lastName,
    address: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.street,
    postcode: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.zipCode,
    location: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.city
  };
};
const useConfirmedOrder = id => {
  const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.context.useOrderHomeContext(),
    resetState = _svs$ticketsOrderHome2.resetState,
    state = _svs$ticketsOrderHome2.state;
  const _state$order = state.order,
    _state$order$orderIte = _state$order.orderItems,
    orderItems = _state$order$orderIte === void 0 ? [] : _state$order$orderIte,
    referenceId = _state$order.referenceId,
    giftAddressState = _state$order.giftAddress,
    isGiftState = _state$order.isGift,
    availableTickets = state.availableTickets;
  const _useState = useState({
      loading: true,
      tickets: [],
      giftAddress: giftAddressState,
      isGift: isGiftState
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    loading = _useState2$.loading,
    tickets = _useState2$.tickets,
    giftAddress = _useState2$.giftAddress,
    isGift = _useState2$.isGift,
    setState = _useState2[1];
  const isMounted = useIsMounted();
  useEffect(() => {
    const fetchOrderItems = async () => {
      let items = [];
      let tempGiftAddress;
      let tempIsGift;
      if (!id || id === referenceId && orderItems.length !== 0) {
        items = orderItems;
        tempGiftAddress = formatGiftAddress(giftAddressState);
        tempIsGift = Boolean(isGiftState);
      } else {
        try {
          const order = await getOrderItemsAsync(id);
          items = order.orderItems || [];
          tempGiftAddress = formatGiftAddress(order === null || order === void 0 ? void 0 : order.giftAddress);
          tempIsGift = order.orderType === GIFT;
        } catch (e) {
          items = [];
        }
      }
      const ticketsOrder = items.map(item => {
        const ticket = availableTickets.find(t => t.id == item.productCode);
        return {
          name: getProductNameAndPrice(ticket),
          count: item.quantity,
          totalPrice: item.quantity * (ticket === null || ticket === void 0 ? void 0 : ticket.price)
        };
      });
      if (isMounted()) {
        resetState();
        setState({
          loading: false,
          tickets: ticketsOrder,
          giftAddress: tempGiftAddress,
          isGift: tempIsGift
        });
      }
    };
    fetchOrderItems();
  }, []);
  const totalOrderPrice = tickets.reduce((a, t) => a + t.totalPrice, 0) + SHIPPING_COST;
  return {
    loading,
    tickets: loading ? [] : tickets,
    giftAddress,
    isGift,
    totalOrderPrice,
    shippingCost: SHIPPING_COST
  };
};
setGlobal('svs.ticketsOrderHome.hooks.useConfirmedOrder', useConfirmedOrder);

 })(window);